import React from 'react';
import ConditionalRenderer, { If } from '@components/ConditionalRenderer';
import { PATHS } from '@constants';
import { Link } from 'react-router-dom';
import Icon from '@components/Icon';
import './style.scss';

const NotifyBadge = ({ newNotifyCount }) => (
  <Link to={PATHS.NOTIFICATIONS} className={`header-notify ${newNotifyCount ? 'active' : ''}`}>
    <Icon type='bell' />
    <ConditionalRenderer condition={newNotifyCount}>
      <If>
        <div className='header-notify__count label-xs'>{newNotifyCount}</div>
      </If>
    </ConditionalRenderer>
  </Link>
);

export default NotifyBadge;
